import { BaseUnits } from "uom";
import { KiloWattHour } from "./energy2";
import { Megajoule, Kilojoule, KiloBtu, MegaBtu } from "./energy";
import { Gram, PoundLb, Grain } from "./mass";
import { massByEnergy } from "../unit-divide";
// Emission
export var KilogramPerKiloWattHour = massByEnergy("KilogramPerKiloWattHour", BaseUnits.Kilogram, KiloWattHour);
export var GramPerKiloWattHour = massByEnergy("GramPerKiloWattHour", Gram, KiloWattHour);
export var GrainPerKiloWattHour = massByEnergy("GrainPerKiloWattHour", Grain, KiloWattHour);
export var PoundLbPerKiloWattHour = massByEnergy("PoundLbPerKiloWattHour", PoundLb, KiloWattHour);
export var GramPerKiloJoule = massByEnergy("GramPerKiloJoule", Gram, Kilojoule);
export var GramPerMegaJoule = massByEnergy("GramPerMegaJoule", Gram, Megajoule);
export var GrainPerKiloBtu = massByEnergy("GrainPerKiloBtu", Grain, KiloBtu);
export var GrainPerMegaBtu = massByEnergy("GrainPerMegaBtu", Grain, MegaBtu);
export var PoundLbPerKiloBtu = massByEnergy("PoundLbPerKiloBtu", PoundLb, KiloBtu);
export var PoundLbPerMegaBtu = massByEnergy("PoundPerMegaBtu", PoundLb, MegaBtu);
//# sourceMappingURL=emission.js.map